
class MessageBuilder {
    constructor() {
        this.message = null;
    }

    /**
     * @return {MessageBuilder}
     */
    resetMessage(){
        this.message = null;
        return this;
    };

    /**
     * @param message
     * @return {MessageBuilder}
     */
    addMessage(message){
        if(!this.message)
            this.message = "";
        this.message += "<li>" + message + "</li>";
        return this;
    };

    /**
     * @return {string|null}
     */
    getMessage(){
        if(this.message){
            return "<ul>" + this.message + "</ul>";
        }
        return null;
    };
}
MessageBuilder.create = () => {
    return new MessageBuilder();
}
export default MessageBuilder;